import { Reveal, MaskWords } from "./Reveal";

const IMG = "/ig/busto.jpg";

export default function ChapterOrigem() {
  return (
    <section
      id="origem"
      className="relative py-32 md:py-48"
      data-testid="chapter-origem"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-6 mb-16 md:mb-24">
            <span className="font-mono-tech text-[11px] text-[var(--accent)]">
              Capítulo 01
            </span>
            <span className="w-24 h-px bg-[var(--line-2)]" />
            <span className="font-mono-tech text-[11px] text-[var(--ink-2)]">
              A história por trás
            </span>
          </div>
        </Reveal>

        <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
          <div className="col-span-12 md:col-span-7 order-2 md:order-1">
            <h2 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-[-0.03em] max-w-[18ch]">
              <MaskWords text="Cada detalhe" />
              <br />
              <MaskWords text="tem uma história." delay={0.1} />
              <br />
              <span className="italic text-[var(--ink-2)]">
                <MaskWords text="Cada criação carrega" delay={0.2} />
              </span>
              <br />
              <span className="italic text-[var(--ink-2)]">
                <MaskWords text="um significado." delay={0.28} />
              </span>
            </h2>

            <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 max-w-[720px]">
              <Reveal delay={0.1}>
                <p className="font-sans text-[15px] leading-[1.75] text-[var(--ink-2)]">
                  A <span className="text-[var(--ink)]">Acervo 3D</span> nasceu
                  para transformar ideias, sentimentos e memórias em peças
                  únicas — feitas para eternizar momentos especiais de uma
                  forma moderna, delicada e cheia de personalidade.
                </p>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="font-sans text-[15px] leading-[1.75] text-[var(--ink-2)]">
                  Aqui, acreditamos que não são apenas objetos — são
                  lembranças, conexões e emoções ganhando forma através do 3D.
                  Um acervo criado com carinho, criatividade e propósito.
                </p>
              </Reveal>
            </div>

            <Reveal delay={0.3}>
              <div className="mt-14 md:mt-20 flex items-center gap-4">
                <span className="w-10 h-px bg-[var(--accent)]" />
                <span className="font-mono-tech text-[11px] text-[var(--ink-2)]">
                  Ateliê independente · Peças sob encomenda
                </span>
              </div>
            </Reveal>
          </div>

          <div className="col-span-12 md:col-span-5 order-1 md:order-2 md:pl-8">
            <Reveal>
              <figure className="relative spotlight aspect-[3/4] md:translate-y-6">
                <img
                  src={IMG}
                  alt="Detalhes delicados — Acervo 3D"
                  className="w-full h-full object-cover"
                />
                <figcaption className="absolute left-4 bottom-4 font-mono-tech text-[10px] text-[var(--ink)] z-10">
                  Fig. 01 — Presente personalizado
                </figcaption>
              </figure>
              <div className="mt-4 flex items-center justify-between font-mono-tech text-[10px] text-[var(--ink-3)]">
                <span>Da foto ao busto</span>
                <span>Peça única</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
